import React from 'react';
import Stack from '@mui/material/Stack';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useSession } from '@hooks';
import { BillingPlanEnum } from '@graphql';
import { APP_TITLE } from '@utils';
import { ConnectFirst, HeroSpot, RegisterStepper } from './components';

const RegisterSpotPage = () => {
  const { account } = useSession();
  const { search } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const plan = searchParams.get('plan') as BillingPlanEnum | null;

  React.useEffect(() => {
    if (plan && !Object.values(BillingPlanEnum).includes(plan)) {
      // Invalid plan, redirect to base register spot page
      setSearchParams({}, { replace: true });
    }
  }, [search]);

  if (!plan) {
    return (
      <RegisterSpotPage.Container>
        <HeroSpot />
      </RegisterSpotPage.Container>
    );
  }

  if (!account) {
    return (
      <RegisterSpotPage.Container>
        <ConnectFirst />
      </RegisterSpotPage.Container>
    );
  }

  if (Object.values(BillingPlanEnum).includes(plan ?? '')) {
    return (
      <RegisterSpotPage.Container>
        <RegisterStepper />
      </RegisterSpotPage.Container>
    );
  }
};

RegisterSpotPage.Container = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation('common');

  return (
    <Stack minHeight="100dvh" alignItems="center">
      <Stack
        p={2}
        width="100%"
        height="100%"
        minHeight="80dvh"
        spacing={4}
        justifyContent="center"
        alignItems="center"
        flex={1}
      >
        {children}
      </Stack>
      <Stack
        width="100%"
        alignItems="center"
        py={5}
        sx={{
          alignSelf: 'flex-end',
          backgroundColor: 'background.paper',
          borderTop: '1px solid #575757',
        }}
      >
        {t('copyright', { year: new Date().getFullYear(), appTitle: APP_TITLE })}
      </Stack>
    </Stack>
  );
};

export default RegisterSpotPage;
